// FETCH ALL GENERAL_PO INWARD DETAILS
export const FETCH_GENERAL_PO_INWARD_DETAILS_REQUEST = 'FETCH_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const FETCH_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'FETCH_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_GENERAL_PO_INWARD_DETAILS_FAILURE = 'FETCH_GENERAL_PO_INWARD_DETAILS_FAILURE';

// FETCH ALL GENERAL_PO INWARD DETAILS
export const FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE GENERAL_PO INWARD DETAILS
export const CREATE_GENERAL_PO_INWARD_DETAILS_REQUEST = 'CREATE_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const CREATE_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'CREATE_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const CREATE_GENERAL_PO_INWARD_DETAILS_FAILURE = 'CREATE_GENERAL_PO_INWARD_DETAILS_FAILURE';

// UPDATE GENERAL_PO INWARD DETAILS
export const UPDATE_GENERAL_PO_INWARD_DETAILS_REQUEST = 'UPDATE_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const UPDATE_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'UPDATE_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const UPDATE_GENERAL_PO_INWARD_DETAILS_FAILURE = 'UPDATE_GENERAL_PO_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF GENERAL_PO INWARD DETAILS
export const FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_FAILURE';

// DELETE GENERAL_PO INWARD DETAILS
export const DELETE_GENERAL_PO_INWARD_DETAILS_REQUEST = 'DELETE_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const DELETE_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'DELETE_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const DELETE_GENERAL_PO_INWARD_DETAILS_FAILURE = 'DELETE_GENERAL_PO_INWARD_DETAILS_FAILURE';

export const RESET_GENERAL_PO_INWARD_DETAILS_INFO = 'RESET_GENERAL_PO_INWARD_DETAILS_INFO';

export const CREATE_GENERAL_PO_INWARD_DETAILS_FORM = 'CREATE_GENERAL_PO_INWARD_DETAILS_FORM';

export const UPDATE_GENERAL_PO_INWARD_DETAILS_FORM = 'UPDATE_GENERAL_PO_INWARD_DETAILS_FORM';


export const GENERAL_PO_INWARD_DETAILS_USERFORM_RESET = 'GENERAL_PO_INWARD_DETAILS_USERFORM_RESET';


export const FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_FAILURE';


export const CREATE_GENERAL_PO_INWARD_DETAILS_GET_REQUEST = 'CREATE_GENERAL_PO_INWARD_DETAILS_GET_REQUEST';
export const CREATE_GENERAL_PO_INWARD_DETAILS_GET_SUCCESS = 'CREATE_GENERAL_PO_INWARD_DETAILS_GET_SUCCESS';
export const CREATE_GENERAL_PO_INWARD_DETAILS_GET_FAILURE = 'CREATE_GENERAL_PO_INWARD_DETAILS_GET_FAILURE';

export const GENERAL_PO_INWARD_DETAILS_PO_DETAILS_DISABLED = 'GENERAL_PO_INWARD_DETAILS_PO_DETAILS_DISABLED';
